import React, { useState } from "react";
import { FaEdit, FaSearch } from "react-icons/fa";
import { SettingGeneralProvider } from "../../../../context/settingGeneralContext";
import TableReusable from "../../../Global/Table";
import EditTreatmentForm from "./FormEditTreatment"

export default function TableTreatmentCategory({
    GetResponseData,
    getData,
    rows,
    page,
    setPage,
    pages,
    changePage,
    msg,
    searchData,
    query,
    setQuery,
    keyword,
    setKeyword,
}) {
    const [viewMode, setViewMode] = useState("table"); // 'table' | 'edit'
    const [selectedTreatment, setSelectedTreatment] = useState(null);
    const handleEdit = (item) => {
        setSelectedTreatment(item);
        setViewMode("edit");
    };

    const handleBackToTable = () => {
        setSelectedTreatment(null);
        setViewMode("table");
    };


    return (
        <SettingGeneralProvider>
            {viewMode === "table" ? (
                <TableTreatmentCategoryContent
                    getData={getData}
                    rows={rows}
                    page={page}
                    setPage={setPage}
                    pages={pages}
                    changePage={changePage}
                    msg={msg}
                    searchData={searchData}
                    query={query}
                    setQuery={setQuery}
                    keyword={keyword}
                    setKeyword={setKeyword}
                    onEdit={handleEdit}
                />
            ) : (
                <EditTreatmentForm
                    GetResponseDataTreatmentCategory={GetResponseData}
                    treatment={selectedTreatment}
                    onBack={handleBackToTable}
                />
            )}
        </SettingGeneralProvider>
    );
}

function TableTreatmentCategoryContent({
    getData,
    rows,
    page,
    pages,
    changePage,
    msg,
    onEdit,
    searchData,
    query,
    setQuery,
    keyword,
    setKeyword
}) {
    const getRowNumber = (index) => (page - 1) * 10 + index + 1;

    return (
        <div style={{ display: "block", height: "100%", overflowY: "auto", overflowX: "auto" }}>

            <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="input-group w-50">
                    <form onSubmit={searchData} style={{ display: "flex", width: "100%" }}>
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Cari nama..."
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                        />
                        <button
                            type="submit"
                            className="btn btn-sm btn-primary"
                        >
                            <FaSearch />
                        </button>
                    </form>

                </div>

            </div>
            <TableReusable
                columns={[
                    { key: "no", label: "No", render: (_, index) => getRowNumber(index) },
                    {
                        key: "name",
                        label: "Name",
                        render: (item) => (
                            <div style={{ textAlign: "left" }}>
                                {item.name}
                            </div>
                        ),
                    },
                    {
                        key: "action",
                        label: "Setup",
                        render: (item) => (
                            <div style={{ display: "flex", gap: "5px" }}>
                                <button
                                    style={{
                                        fontSize: "12px",
                                        color: "white",
                                        backgroundColor: "#ff9933",
                                        padding: "5px 5px",
                                        borderRadius: "3px",
                                        cursor: "pointer",
                                        border: "none",
                                        display: "flex",
                                    }}
                                    onClick={() => onEdit(item)}
                                >
                                    <FaEdit />
                                </button>
                            </div>
                        ),
                    },
                ]}
                data={getData}
                rows={rows}
                page={page}
                pages={pages}
                changePage={changePage}
                msg={msg}
            />
        </div>
    );
}
